import { notification } from "antd";
import { isInIframe } from "@/shared/lib/document-view/is-in-iframe";
import { fetchS3FileUrl } from "@shared/api";
import { NOTIFICATION_MESSAGES } from "./notification-messages";

type UnifiedFilePayload = {
  fileUrl: string;
  fileName?: string;
};

export const requestUnifiedOpen = ({ fileUrl, fileName }: UnifiedFilePayload) => {
  if (!fileUrl) {
    notification.error({
      message: "Ошибка при открытии",
      description: "Ссылка на документ не найдена",
    });
    return;
  }

  if (isInIframe()) {
    window.parent.postMessage(
      {
        type: "read-file",
        fileUrl,
        fileName,
      },
      "*",
    );
  }
};

export const requestUnifiedDownload = ({
  fileUrl,
  fileName,
}: UnifiedFilePayload) => {
  if (!fileUrl) {
    notification.error({
      message: NOTIFICATION_MESSAGES.DOWNLOAD_ERROR,
      description: NOTIFICATION_MESSAGES.DOWNLOAD_NO_LINK_DESC,
    });
    return;
  }

  try {
    if (isInIframe()) {
      window.parent.postMessage(
        {
          type: "unified-download",
          fileUrl,
          fileName,
        },
        "*",
      );
    } else {
      const link = document.createElement("a");
      link.href = fileUrl;
      if (fileName) {
        link.download = fileName;
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch {
    notification.error({
      message: NOTIFICATION_MESSAGES.DOWNLOAD_ERROR,
      description: NOTIFICATION_MESSAGES.DOWNLOAD_INIT_FAILED_DESC,
    });
  }
};

export const downloadFileUnifiedById = async (
  fileId: string,
  setLoading: (fileId: string, loading: boolean) => void,
  fileName?: string,
) => {
  setLoading(fileId, true);
  try {
    const fileUrl = await fetchS3FileUrl(fileId);
    requestUnifiedDownload({ fileUrl, fileName });
  } catch {
    notification.error({
      message: NOTIFICATION_MESSAGES.DOWNLOAD_ERROR,
      description: NOTIFICATION_MESSAGES.DOWNLOAD_FILE_ERROR_DESC,
    });
  } finally {
    setLoading(fileId, false);
  }
};

/** iframe: type=url → read-file. Не использовать для standalone preview. */
export const openFileUnifiedById = async (
  fileId: string,
  setLoading: (fileId: string, loading: boolean) => void,
  fileName?: string,
) => {
  setLoading(fileId, true);
  try {
    const fileUrl = await fetchS3FileUrl(fileId);
    requestUnifiedOpen({ fileUrl, fileName });
  } catch {
    notification.error({
      message: "Ошибка при открытии",
      description: "Не удалось открыть документ",
    });
  } finally {
    setLoading(fileId, false);
  }
};
